<template>
  <v-layout column>
    <v-layout>
      <top-info-panel >
        <v-flex xs12 md12 lg6 xl5 px-2  slot="content" >
            <h4>Beheer uw assetsoorten</h4>
            <p>Door uw assets een soort definitie te geven is er duidelijker onderscheid te maken tussen de diverse soorten en de gedragingen die daarmee gepaard gaan</p>
        
        </v-flex>
      </top-info-panel>
    </v-layout>
    <v-layout wrap px-3 align-center justify-center class="inset">
      
      <v-flex xs12 md12 lg6 xl5 pt-2>
          
          <v-widget title="Assetsoorten beheren" class="" title-text-color="">
            <v-btn fab dark  color="accent" slot="button-top-right" @click="newAssetType()" v-if="!selectedAssetType">
                <v-icon dark>add</v-icon>
            </v-btn>  
            <v-layout slot="widget-content">
              <v-layout row wrap slot="content">
                  <v-flex xs12 sm12 lg12 v-if="!selectedAssetType">
                    <v-card-text>
                    <v-list dense> 
                      <v-list-tile active-class="primary darken-2" @click="loadForm(type)" avatar v-for="type of assetTypes" :key="type.id">
                          <v-list-tile-avatar> <i class="fas fa-cubes fa-1x primary--text text--lighten-2"></i>  </v-list-tile-avatar>                      
                          <v-list-tile-title v-html="type.name"></v-list-tile-title>                                               
                      </v-list-tile>                  
                    </v-list>                
                    </v-card-text>
                  </v-flex>
                  <v-flex  v-if="selectedAssetType" px-3 py-3> 
                    <v-form
                      ref="form"
                      v-model="valid"
                      lazy-validation
                    >
                    <v-flex>                                    
                      <v-text-field                    
                        v-model="selectedAssetType.name"                     
                        label="Naam"
                        :rules="nameRules"
                        required
                      ></v-text-field>
                      </v-flex>
                      <v-flex row >                  
                        <v-layout >
                          <v-btn                          
                              color="info"                      
                              @click="clearCurrent"> 
                              annuleren
                            </v-btn>                                                                                                         
                            <v-spacer></v-spacer>
                            <v-btn                                                
                              color="error"
                              :disabled="!selectedAssetType.canBeDeleted"
                              > 
                              Verwijder
                            </v-btn>                                           
                            <v-btn                                                
                              :disabled="!valid"
                              color="success"
                              @click="saveForm">
                              Opslaan
                            </v-btn>                        
                        </v-layout>                                                                    
                      </v-flex>                 
                    </v-form>
                  </v-flex>
                </v-layout>    
              </v-layout>              
          </v-widget>
        </v-flex>
    </v-layout>  
  </v-layout>
</template>
<script>

import * as types from "../../store/types"
import { mapGetters } from 'vuex'
import TopInfoPanel from "../../components/global/TopInfoPanel"
import VWidget from "../../components/global/VWidget"
import DdPage from '../../components/global/DdPage'


export default {
  components: {
    VWidget,
    DdPage,
    TopInfoPanel
  },
  data() {
    return  {
      valid:true,
      selectedAssetType:{},
      nameRules:[
        v => !!v || "Naam is verplicht"
      ]
    }
  },
  computed: {
    ...mapGetters({
      assetTypes: types.ASSET_TYPES
    })
  },
  methods: {
    saveForm(){
      if (this.$refs.form.validate()) {

          this.$store.dispatch(types.SAVE_ASSET_TYPE, {data:this.selectedAssetType} ).then((res) => {
              
              // reload list after save                        
              this.$store.dispatch(types.ASSET_TYPES,{params:{per_page:200}}).then(() => {                                    
                  //this.selectedAssetGroup = this.assetGroups.find( (item) => item.id == res.id)
                  this.clearCurrent();
              })              
          });
      }
    },
    loadForm(assetType){
      let selectedType={}
      Object.assign(selectedType, assetType)
      this.selectedAssetType = selectedType
    },
    deleteGroup(){
        this.$store.dispatch(types.DELETE_ASSET_TYPE, {data:{id:this.selectedAssetType.id}} ).then(() => {
          this.$store.dispatch(types.ASSET_TYPES,{params:{per_page:200}})
          this.clearCurrent();
        })      
    },
    clearCurrent(){
      this.selectedAssetType = null    
      //this.$refs.form.reset()
    },
    newAssetType(){
      this.selectedAssetType  = {id:"",
                                 name:"",
                                 creationDate:"",
                                 lastChange:""}  
      //this.$refs.form.resetValidation()
    }
  },
  mounted() {
    this.clearCurrent();
    this.$store.dispatch(types.ASSET_TYPES,{params:{per_page:200}});

    this.$store.dispatch(types.CURRENT_BREADCRUMBS, [
      {text: 'Home', href: '/', disabled: false},
      {text: 'Instellingen', href: '/settings', disabled: false},
      {text: 'Asset typen', href: '/settings/asset-types', disabled: false},
      // {text: 'FLU0000001', disabled: true},      
    ])
    this.$store.dispatch(types.BACKGROUND_ICON, 'cogs');
  },  
  beforeDestroy(){
    this.$store.dispatch(types.BACKGROUND_ICON, null);
  }  
}
</script>
<style>
.dd-detail-list li{
  list-style-type: none;
  padding-bottom: 4px;
  padding-left: 4px;
  border-bottom: 1px solid black;
  background-color: blue-gey lighten-5;
}
</style>
